/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PluginFailureRecord interface.
 */
export function instanceOfPluginFailureRecord(value) {
    if (!('brand' in value) || value['brand'] === undefined)
        return false;
    if (!('deviceId' in value) || value['deviceId'] === undefined)
        return false;
    if (!('errorMessage' in value) || value['errorMessage'] === undefined)
        return false;
    if (!('extensionVersion' in value) || value['extensionVersion'] === undefined)
        return false;
    if (!('failureStage' in value) || value['failureStage'] === undefined)
        return false;
    if (!('reportId' in value) || value['reportId'] === undefined)
        return false;
    if (!('sessionStatus' in value) || value['sessionStatus'] === undefined)
        return false;
    return true;
}
export function PluginFailureRecordFromJSON(json) {
    return PluginFailureRecordFromJSONTyped(json, false);
}
export function PluginFailureRecordFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'brand': json['brand'],
        'browser': json['browser'] == null ? undefined : json['browser'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'deviceId': json['device_id'],
        'errorMessage': json['error_message'],
        'extensionVersion': json['extension_version'],
        'failureStage': json['failure_stage'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'reportId': json['report_id'],
        'sessionStatus': json['session_status'],
        'suppressedCount': json['suppressed_count'] == null ? undefined : json['suppressed_count'],
        'uid': json['uid'] == null ? undefined : json['uid'],
    };
}
export function PluginFailureRecordToJSON(json) {
    return PluginFailureRecordToJSONTyped(json, false);
}
export function PluginFailureRecordToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'brand': value['brand'],
        'browser': value['browser'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'device_id': value['deviceId'],
        'error_message': value['errorMessage'],
        'extension_version': value['extensionVersion'],
        'failure_stage': value['failureStage'],
        'provider': value['provider'],
        'report_id': value['reportId'],
        'session_status': value['sessionStatus'],
        'suppressed_count': value['suppressedCount'],
        'uid': value['uid'],
    };
}
